
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Swal from 'sweetalert2';

const { otherPoint } = api;

@Component({
  components: { },
})
export default class OtherPointList extends Vue {
  public data = [];

  public loading = false;

  public panel = 0;

  public headers = [
    { text: 'ID', value: 'pointId' },
    { text: '合作商店名稱', value: 'pointName' },
    { text: '合作商店圖片', value: 'iconUrl' },
    { text: '排序', value: 'sort' },
    { text: '換入提醒', value: 'itemId' },
    { text: '優惠活動管理', value: 'activity' },
    { text: '編輯', value: 'edit' },
    { text: '啟用', value: 'status' },
  ];

  public get collection() {
    return [...(this.data || [])];
  }

  public filter = {
    q: this.$route.query.q || undefined,
  };

  public async query() {
    const query = {
      ...this.filter,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  public async reset() {
    this.filter = {
      q: undefined,
    };
    await this.query();
  }

  public async handleEnableStatus(pointId: any, IsEnabled: boolean) {
    const message = IsEnabled ? '停用' : '啟用';
    await Swal.fire(
      {
        title: `您確定要${message}嗎?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = IsEnabled ? await otherPoint.disable(pointId) : await otherPoint.enable(pointId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: `${message}成功` });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: `${message}失敗，請聯繫系統管理員。` });
        }
      }
    });
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await otherPoint.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: OtherPointList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
